<script setup lang="ts">
import { computed, useSlots } from 'vue'

// One of the two variants of a modal header
// This one contains a title and a description
// https://www.figma.com/file/1HfA941cU4A9RZxXHLmbpG/V7-Design-System-(WIP)?type=design&node-id=1697-16013&mode=design&t=wFkzpO9SwKxhAPQZ-0

// While the figma designs also show a button on the top right,
// because that button affects behavior of the parent component,
// it's simpler to have the parent component render it positioned absolutely
const props = defineProps<{
  title: string
  description?: string
  titleId?: string
}>()

const { description: descriptionSlot } = useSlots()
const hasDescription = computed(() => Boolean(descriptionSlot || props.description))
</script>

<template>
  <div
    class="flex flex-col gap-1"
    :class="hasDescription ? 'items-start px-5 py-4' : 'items-center py-3'"
  >
    <h2
      :id="titleId"
      :class="[
        hasDescription && 'mr-4 text-lg-15px-bold text-text',
        !hasDescription && 'text-center text-sm-12px-default text-text-subtle',
      ]"
    >
      {{ title }}
    </h2>
    <div
      v-if="hasDescription"
      class="max-w-prose text-sm-12px-default whitespace-pre-wrap text-text-subtle"
    >
      <slot name="description">
        {{ description }}
      </slot>
    </div>
  </div>
</template>
